import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { Button, Stack, Text, Container, Group, Title, Box } from "@mantine/core";
import { getRedirectUri, loginRequest, checkLoggedIn } from "../../authConfig";
import { useAuthContext } from "../../loginContext";
import { MdOutlineAutoAwesome } from "react-icons/md";

export const Login = () => {
    const { instance } = useMsal();
    const { login, logout } = useAuthContext();
    const { t } = useTranslation();

    const handleLoginPopup = () => {
        /**
         * When using popup and silent APIs, we recommend setting the redirectUri to a blank page or a page
         * that does not implement MSAL. Keep in mind that all redirect routes must be registered with the application
         * For more information, please follow this link: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations
         */
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: getRedirectUri()
            })
            .catch(error => console.log(error))
            .then(async () => {
                const test = await checkLoggedIn(instance);
                if (test) {
                    login();
                } else {
                    logout();
                }
            });
    };

    return (
        <Container size="xs" h="100vh" display="flex" style={{ flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <Stack align="stretch" justify="center" gap="md" w={"100%"}>
                <Group gap="sm" justify="center" align="center" flex={{ grow: 1 }} mb="md">
                    <Title order={3} c="dark.8">
                        {t("welcome")}
                    </Title>
                    <Box w={16} h={16} display="flex" c="dark.8">
                        <MdOutlineAutoAwesome size={16} />
                    </Box>
                </Group>
                <Button onClick={handleLoginPopup} fullWidth>
                    {t("loginMessage")}
                </Button>
            </Stack>
        </Container>
    );
};
